import React from 'react';
import PropTypes from 'prop-types';
import { manageTranslations as TranslationHelper } from '@morsedigital/i18n_helper';

const wp = TranslationHelper('javascript')('weekly_programme');

const circleStyles = {
  stroke: '#e14e00',
  strokeWidth: '2px',
  fill: 'transparent',
};

const lineStyles = {
  stroke: '#e14e00',
  strokeWidth: '2px',
};

const ellipseStyles = {
  fill: '#e14e00',
  stroke: '#e14e00',
  strokeWidth: '2px',
};

const ExpandBtn = ({ className, onClick }) => (
  <div className={className}>
    <button onClick={onClick} className="svg-information" title={wp('additional.more_info')}>
      <svg id="icons" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 42 42" width="35" height="35">
        <title>{wp('additional.more_info')}</title>
        <circle style={circleStyles} cx="21" cy="21" r="20" />
        <line style={lineStyles} x1="21" y1="17.4" x2="21" y2="31.2" />
        <ellipse style={ellipseStyles} cx="21" cy="11.2" rx="0.6" ry="0.4" />
      </svg>
    </button>
  </div>
);

ExpandBtn.propTypes = {
  className: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default ExpandBtn;
